module.exports = __webpack_public_path__ + "static/media/siri24.f599a3c0.jpg";